<template lang="pug">
  div.stu-footer
    div
      div.fl.text-ct.stu-footer-info
        span.fl
          a.fl.f12.grey9(href='/static/page/youngsters.html' target='_blank') {{$t('footer.youth')}}
          i
        span.fl
          a.fl.f12.grey9(href='/static/page/declare.html' target='_blank') {{$t('footer.declare')}}
          i
        span.fl
          a.fl.f12.grey9(href='/static/page/private.html' target='_blank') {{$t('footer.private')}}
          i
        span.fl.f12.grey9
          | {{ copyright + cfName + $t('footer.copyright') }}
          i
        span.fl.f12.grey9
          a.f12.grey9(href='http://beian.miit.gov.cn' target='_blank') {{ icp }}
        span.fl.f12.gong-an(v-if='icon')
          a.f12.grey9(:href='"http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=" + police' target='_blank' name='abc') 苏公网安备{{police}}号
        div.stu-footer-browser
          a.fl.f12.grey9(href='http://17ks.chivoxapp.com/guide/360Browse.exe') 
            img.fl(src='@/assets/image/common/icon_browser-360.png' alt='360')
            | {{$t('footer.browser360')}}
          a.fl.f12.grey9(href='http://17ks.chivoxapp.com/guide/QQBrowser.exe')
            img.fl(src='@/assets/image/common/icon_browser-qq.png' alt='QQ')
            | {{$t('footer.browserqq')}}
      div.fl.text-ct.stu-footer-info(v-if="false")
        span.fl.f12.grey9  {{$t('footer.djg')}}
        span.fl
          a.fl.f12.grey9(:href='"http://system.eduyun.cn/bmp-web/getSpAppDetail_index?appId=SvPWErV8CGBKuSJ6EgYosAb7lxqFzFK7&userId=" + djgId' target='_blank') {{$t('footer.pj')}}
          i
        span.fl
          a.fl.f12.grey9(:href='"http://system.eduyun.cn/bmp-web/sysAppReport/appReport?appId=SvPWErV8CGBKuSJ6EgYosAb7lxqFzFK7&userId=" + djgId' target='_blank') {{$t('footer.jb')}}
</template>

<script>
export default {
  name: 'Footer',
  data() {
    const { cfName } = window.ConfigNew.header
    const { copyright, icp, police, icon } = window.ConfigNew.footer
    const djgId = localStorage.getItem('djg-id')
    return {
      cfName,
      copyright,
      icp,
      police,
      icon,
      djgId
    }
  },
  mounted() {
    window.renderFooter()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Stu/footer.vue